import { cva } from 'class-variance-authority'

// Styles for the ProgressPrimitive.Root
export const rootStyles = cva(
  `
    relative
    h-2
    w-full
    overflow-hidden
    rounded-[24px]
    bg-neutral-50
  `,
  {
    variants: {
      variant: {
        primary: `
          bg-neutral-50
        `,
        segmented: `
          bg-neutral-50
        `,
      },
      size: {
        default: `
        `,
        large: `
          rounded-[8px]
          h-6
          w-full
        `,
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  }
)

// Styles for the ProgressPrimitive.Indicator
export const indicatorStyles = cva(
  `
    h-full
    flex-1
    transition-all
    rounded-[24px]
  `,
  {
    variants: {
      variant: {
        primary: `
          bg-moss-200
        `,
        segmented: `
          bg-moss-200
        `,
      },
      size: {
        default: `
          rounded-[24px]
        `,
        large: `
          rounded-[8px]
          h-6
          w-full
        `,
      },
    },
    defaultVariants: {
      variant: 'primary',
    },
  }
)
